import { render, staticRenderFns } from "./DashboardTicket.vue?vue&type=template&id=5f87015b&scoped=true&"
import script from "./DashboardTicket.vue?vue&type=script&lang=js&"
export * from "./DashboardTicket.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTicket.vue?vue&type=style&index=0&id=5f87015b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f87015b",
  null
  
)

export default component.exports